import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import axios from '@/services/axios';
import router from '@/router';

const store = createStore({
  plugins: [
    createPersistedState()
  ],
  state: {
    authenticated: false,
    user: null,
    token: null,
    role: null,
    app: {
      name: 'ตารางเวรออนไลน์',
      name_en: 'NURSE SHIFT WNH'
    },
    userGroups: [],
    loading: false,
    error: null,
  },
  mutations: {
    authenticateUser(state, data) {
      state.authenticated = true;
      state.user = data.user;
      state.token = data.token;
      state.role = data.role;
    },
    unauthenticateUser(state) {
      state.authenticated = false;
      state.user = null;
      state.token = null;
      state.role = null;
    },
    SET_USER_GROUPS(state, userGroups) {
      state.userGroups = userGroups;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    logout(state) {
      state.authenticated = false;
      state.user = null;
      state.token = null;
      state.role = null;
    },
  },
  actions: {
    async checkToken({ commit }) {
      const token = localStorage.getItem('token');
      if (!token) {
        commit('logout');
        return;
      }

      try {
        await axios.get('/api/check-token'); // Create an endpoint in your Laravel API
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } catch (error) {
        if (error.response && error.response.status === 401) {
          commit('logout');
          await router.push({ name: 'login' });
        }
      }
    },
    async login({ commit }, credentials) {
      await axios.get('sanctum/csrf-cookie');
      const res = await axios.post('api/login', credentials);
      commit('authenticateUser', res.data);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('role', res.data.role);

      await axios.get('api/user');
      await router.push({ name: 'dashboard' });
    },
    async logout({ commit }) {
      try {
        await axios.post('api/logout', {}, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        });
      } catch (error) {
        if (error.response && error.response.status === 404 && error.response.data.message === "Token not found") {
          // Handle 404 response specifically
          console.error("Token not found, redirecting to login...");
          commit('unauthenticateUser');
          localStorage.removeItem('token');
          localStorage.removeItem('role');
          await router.push({ name: 'login' });
          return; // Exit the function early
        }

        // Handle other errors if needed
        console.error("Logout error:", error);
      }

      // If logout is successful, proceed with normal flow
      commit('unauthenticateUser');
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      await router.push({ name: 'login' });
    },
    // async logout({ commit }) {
    //   const token = localStorage.getItem('token');

    //   await axios.post('api/logout', {
    //     headers: {
    //       'Authorization': `Bearer ${token}`
    //     }
    //   });
    //   commit('unauthenticateUser');
    //   localStorage.removeItem('token');
    //   localStorage.removeItem('role');
    //   await router.push({ name: 'login' });
    // },
    async getUserGroup({ commit, state }) {
      const userId = state.user.id; // Get user ID from state
      if (!userId) {
        commit('SET_ERROR', { message: 'User ID is not available' });
        return;
      }

      commit('SET_LOADING', true);
      try {
        const response = await axios.get(`api/user-groups?user_id=${userId}`);
        commit('SET_USER_GROUPS', response.data);
      } catch (error) {
        commit('SET_ERROR', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
  getters: {
    isAuthenticated(state) {
      return state.authenticated;
    },
    user(state) {
      return state.user;
    },
    userToken(state) {
      return state.token;
    },
    userGroups: (state) => state.userGroups,
    isLoading: (state) => state.loading,
    error: (state) => state.error,
  },
});

export default store;
